import { Component, OnInit } from '@angular/core';
import { ParentFormGroup } from 'app/tools/parent-formgroup';

@Component({
  selector: 'text-inscricao-municipal',
  templateUrl: './text-inscricao-municipal.component.html',
  styleUrls: ['./text-inscricao-municipal.component.scss'],
  viewProviders: [ParentFormGroup]
})
export class TextInscricaoMunicipalComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
